<div class="client-layout" cdkDropListGroup>
	<!-- Left Sidebar - hidden only when the new analytics panel is actually showing (ANALYTICS +
	     Client.newAnalytics): it has its own left menu and needs the full width instead (see
	     .main-content--analytics / .content-inner--analytics below). The old chart grid (when
	     newAnalytics is off) still needs this sidebar, same as before the new panel existed. -->
	@if (dataAdministrationType !== 'ANALYTICS' || !client?.newAnalytics) {
	<aside class="sidebar" [style.width.px]="mobileView ? '100%' : 300" [style.display]="mobileView ? 'none' : 'flex'">
		<div class="sidebar-scroll custom-scrollbar">

			<!-- Breadcrumb -->
			<div class="sidebar-breadcrumb">
				<app-nav-map [load]="dataAdministrationType"></app-nav-map>
			</div>

			<!-- Tags / Categories -->
			@if (hasCategoriesSection) {
			<div class="sidebar-section categories-section">
				@if (dataAdministrationType !== 'CLIPPING') {
					<h3 class="section-label">{{ 'ASSORTED.CATEGORIES' | translate }}</h3>
				}
				<div class="sidebar-tags custom-scrollbar">
					<app-tags [role]="'client'" [class.tags--clipping]="dataAdministrationType === 'CLIPPING'" [class.tags--rest]="isRestTab" (actionRequested)="actionByTypeSplitter($event)"></app-tags>
				</div>
			</div>

			}
		</div>
	</aside>
	}

	<!-- Main Content -->
	<main class="main-content"
		[class.main-content--analytics]="dataAdministrationType === 'ANALYTICS' && !!client?.newAnalytics"
		infinite-scroll
		[infiniteScrollDistance]="scrollDistance"
		[infiniteScrollThrottle]="throttle"
		(wheel)="scrollPosition($event)"
		(scrolled)="onScrollDown($event)"
		[scrollWindow]="false"
		[alwaysCallback]="true">
		<div class="content-inner" [class.content-inner--analytics]="dataAdministrationType === 'ANALYTICS' && !!client?.newAnalytics">
			<span #inputFormAnchor></span>

			@if (dataAdministrationType === 'TRANSCRIPTIONS' && itemForEdit.transcription) {
			<mat-card class="pb-2 pt-1 framed-content mb-4">
				<app-shared-transcriptions-form [itemForEdit]="itemForEdit.transcription" [mode]="'client'" [initialSeconds]="transcriptionDeepLinkSeconds" (actionRequested)="actionByTypeSplitter($event)"></app-shared-transcriptions-form>
			</mat-card>
			}

			<span #listScrollAnchor></span>

			<!-- Content header -->
			@if (dataAdministrationType !== 'ANALYTICS') {
			<div class="content-header" [class.content-header--clipping]="dataAdministrationType === 'CLIPPING'" [class.content-header--rest]="isRestTab">
				<div class="content-header-left">
					@if (dataAdministrationType === 'TRANSCRIPTIONS') {
					<div class="header-search">
						<mat-icon>search</mat-icon>
						<input
							type="text"
							[ngModel]="transcriptionSearchText"
							(ngModelChange)="onTranscriptionSearchChange($event)"
							(keyup.enter)="triggerTranscriptionSearch()"
							placeholder="{{ 'BUTTON.SEARCH' | translate }}" />
						@if (transcriptionSearchText) {
						<mat-icon class="header-search-clear" (click)="transcriptionSearchText = ''; triggerTranscriptionSearch()">close</mat-icon>
						}
						<mat-icon
							#transcriptionSearchHelpTooltip="matTooltip"
							class="header-search-help"
							matTooltipClass="wide-tooltip"
							matTooltipPosition="above"
							[matTooltip]="'TRANSCRIPTIONS.SEARCH_HELP_TEXT_CLIENT' | translate"
							(click)="transcriptionSearchHelpTooltip.toggle()">info_outline</mat-icon>
					</div>
					}
				</div>
				<div class="content-header-right">
					<button class="header-action-btn" [matMenuTriggerFor]="listSortMenu" aria-label="Sort list">
						@if (dataAdministrationType === 'CLIPPING') {
							{{ clipsSortLabelKey | translate }}
						} @else {
							{{ (listSort === 'newest' ? 'ASSORTED.NEWEST_FIRST' : 'ASSORTED.OLDEST_FIRST') | translate }}
						}
						<mat-icon>expand_more</mat-icon>
					</button>
					<mat-menu #listSortMenu="matMenu">
						@if (dataAdministrationType === 'CLIPPING') {
							<button mat-menu-item (click)="onClipsSortChange('newest')">{{ 'ASSORTED.NEWEST_FIRST' | translate }}</button>
							<button mat-menu-item (click)="onClipsSortChange('oldest')">{{ 'ASSORTED.OLDEST_FIRST' | translate }}</button>
							@if ((sharedService.companyTagIds | async)?.size) {
							<button mat-menu-item (click)="onClipsSortChange('mostReach')">{{ 'ASSORTED.MOST_REACH' | translate }}</button>
							<button mat-menu-item (click)="onClipsSortChange('leastReach')">{{ 'ASSORTED.LEAST_REACH' | translate }}</button>
							<button mat-menu-item (click)="onClipsSortChange('mostInfluence')">{{ 'ASSORTED.MOST_INFLUENCE' | translate }}</button>
							<button mat-menu-item (click)="onClipsSortChange('leastInfluence')">{{ 'ASSORTED.LEAST_INFLUENCE' | translate }}</button>
							}
						} @else {
							<button mat-menu-item (click)="onListSortChange('newest')">{{ 'ASSORTED.NEWEST_FIRST' | translate }}</button>
							<button mat-menu-item (click)="onListSortChange('oldest')">{{ 'ASSORTED.OLDEST_FIRST' | translate }}</button>
						}
					</mat-menu>
					@if (dataAdministrationType === 'CLIPPING') {
					<button class="header-action-btn" matTooltip="{{ 'CLIPS.GENERATE_AI_SUMMARY_INFO' | translate }}" matTooltipClass="wide-tooltip" (click)="generateAiSummary()">
						<mat-icon fontSet="material-icons-outlined">photo_filter</mat-icon>
						{{ 'CLIPS.GENERATE_AI_SUMMARY' | translate }}
					</button>
					<button class="header-action-btn" matTooltip="{{ 'CLIPS.GENERATE_XLS_REPORT_INFO' | translate }}" matTooltipClass="wide-tooltip" (click)="exportClientClips()">
						<mat-icon>download</mat-icon>
						{{ 'CLIPS.GENERATE_XLS_REPORT' | translate }}
					</button>
					}
					@if (dataAdministrationType === 'CONTRACT_NOTICES' || dataAdministrationType === 'CONTRACT_ANNOUNCEMENTS') {
					<button class="header-action-btn" (click)="dataAdministrationType === 'CONTRACT_NOTICES' ? exportClientContractNotices() : exportClientContractAnnouncements()">
						<mat-icon>download</mat-icon>
						{{ (dataAdministrationType === 'CONTRACT_NOTICES' ? 'CONTRACT_NOTICES.EXPORT' : 'CONTRACT_ANNOUNCEMENTS.EXPORT') | translate }}
					</button>
					}
					@if (dataAdministrationType === 'SALES') {
					<button class="header-action-btn" (click)="exportClientSales()">
						<mat-icon>download</mat-icon>
						{{ 'SALES.EXPORT' | translate }}
					</button>
					}
					@if (dataAdministrationType === 'BANKRUPTCIES') {
					<button class="header-action-btn" (click)="exportClientBankruptcies()">
						<mat-icon>download</mat-icon>
						{{ 'BANKRUPTCIES.EXPORT' | translate }}
					</button>
					}
					@if (dataAdministrationType === 'TRANSCRIPTIONS') {
					<!-- Client transcriptions are read-only: record audio + transcribe hidden.
					<button class="header-action-btn" [class.recording]="transcriptionsFiltersComponent?.isRecording" [disabled]="!transcriptionsFiltersComponent" (click)="transcriptionsFiltersComponent?.toggleRecording()" matTooltip="{{ (transcriptionsFiltersComponent?.isRecording ? 'TRANSCRIPTIONS.STOP_RECORDING' : 'TRANSCRIPTIONS.RECORD_AUDIO') | translate }}">
						<mat-icon>{{ transcriptionsFiltersComponent?.isRecording ? 'voice_over_off' : 'record_voice_over' }}</mat-icon>
						{{ (transcriptionsFiltersComponent?.isRecording ? 'TRANSCRIPTIONS.STOP_RECORDING' : 'TRANSCRIPTIONS.RECORD_AUDIO') | translate }}
					</button>
					<button class="header-action-btn" (click)="openCreateTranscriptionDialog()" matTooltip="{{ 'TRANSCRIPTIONS.TRANSCRIBE' | translate }}">
						<mat-icon>upload</mat-icon>
						{{ 'TRANSCRIPTIONS.TRANSCRIBE' | translate }}
					</button>
					-->
					}
				</div>
			</div>
			}

			@if (dataAdministrationType === 'ANALYTICS') {
			@if (client?.newAnalytics) {
			<!-- New analytics panel (feature/analytics-panel) - only for clients with the
				 "Нова аналитика" toggle on (Client.newAnalytics, off by default). -->
			<app-analytics-panel></app-analytics-panel>
			} @else {
			<!-- Old chart grid, exactly as it was before the new analytics panel existed. -->
			<mat-card class="framed-content pt-2">
				<mat-card class="list-card mat-elevation-z8 m-2 mt-0">
					<mat-card-header class="p-0">
						<mat-card-title class="ms-3 me-2"></mat-card-title>
					</mat-card-header>
					<mat-card-content class="p-3 pb-0 d-flex flex-wrap">
						<div class="w-100 p-4">
							<h6 class="analytics-title">{{ 'ANALYTICS.CLIPS_BY_DATE' | translate }}</h6>
							<app-time-series-chart [data]="clipsByDate" xAxisField="date" yAxisField="clipsCount" />
						</div>
						<div class="w-100 p-4">
							<h6 class="analytics-title">{{ 'ANALYTICS.CLIPS_BY_TAG' | translate }}</h6>
							<app-rotated-labels-column-chart [data]="clipsByTag" [categoryField]="'tagName'" [valueField]="'clipsCount'" />
						</div>
						<div class="w-100 p-4">
							<h6 class="analytics-title">{{ 'ANALYTICS.CLIPS_BY_MEDIUM' | translate }}</h6>
							<app-rotated-labels-column-chart [data]="clipsByMedium" [categoryField]="'mediumName'" [valueField]="'clipsCount'" />
						</div>
						<div class="w-100 p-4">
							<h6 class="analytics-title">{{ 'ANALYTICS.CLIPS_BY_SENTIMENT' | translate }}</h6>
							<app-progress-chart [data]="clipsBySentiment" />
						</div>
						<div class="w-100 p-4">
							<h6 class="analytics-title">{{ 'ANALYTICS.CLIPS_BY_AUTHOR' | translate }}</h6>
							<app-simple-treemap-chart [data]="clipsByAuthor"></app-simple-treemap-chart>
						</div>
						<div class="w-100 p-4">
							<h6 class="analytics-title">{{ 'ANALYTICS.WORD_CLOUD' | translate }}</h6>
							<app-word-cloud-chart [data]="commonWords"></app-word-cloud-chart>
						</div>
					</mat-card-content>
				</mat-card>
			</mat-card>
			}
			} @else {

			@if (dataAdministrationType === 'CLIPPING') {
			<app-client-clipping-stats
				[hasCompanyTags]="!!(sharedService.companyTagIds | async)?.size"
				[reloadKey]="dataAdministrationType"
				(openClip)="onMostValuableClipOpen($event)">
			</app-client-clipping-stats>
			<div class="stats-separator"></div>
			}

			<!-- Cards list -->
			@for (item of itemsList; track $index) {
			<app-client-data-card
				[item]="item"
				[dataAdministrationType]="dataAdministrationType"
				[resellerSettingsContext]="resellerSettingsContext"
				[client]="client"
				(actionRequested)="actionByTypeSplitter($event)">
			</app-client-data-card>
			}
			}
		</div>
	</main>

	<!-- Right-hand filters panel. Keeps a 22px rail visible when collapsed so the toggle
	     always has its own space and never sits on top of the content's scrollbar.
	     Hidden for ANALYTICS only when the new analytics panel is actually showing (it has its
	     own in-page filter bar) - the old chart grid still needs this sidebar, same as before. -->
	@if (dataAdministrationType !== 'ANALYTICS' || !client?.newAnalytics) {
	<aside class="filters-panel" [class.collapsed]="!filtersPanelOpen" [style.display]="mobileView ? 'none' : 'flex'">
		<!-- Header stays outside the scroll area so the toggle survives the collapse -->
		<div class="filters-panel-header">
			<button
				type="button"
				class="filters-panel-toggle"
				(click)="toggleFiltersPanel()"
				[matTooltip]="(filtersPanelOpen ? 'ASSORTED.HIDE_ADVANCED_FILTERS' : 'ASSORTED.SHOW_ADVANCED_FILTERS') | translate"
				matTooltipPosition="left"
				[attr.aria-label]="(filtersPanelOpen ? 'ASSORTED.HIDE_ADVANCED_FILTERS' : 'ASSORTED.SHOW_ADVANCED_FILTERS') | translate"
				[attr.aria-expanded]="filtersPanelOpen">
				<mat-icon>{{ filtersPanelOpen ? 'chevron_right' : 'chevron_left' }}</mat-icon>
			</button>
			<h3 class="section-label">{{ 'ASSORTED.FILTERS' | translate }}</h3>
		</div>

		<div class="filters-panel-scroll custom-scrollbar">
			<!-- `sidebar-section filters-section` kept as the class hook: the compact single-column
			     styling for every client filter form is defined globally against those two classes. -->
			<div class="sidebar-section filters-section">
				@switch (dataAdministrationType) {
				@case ('CLIPPING') { @if (showFilters) {
				<app-clips-filters [role]="'client'" [hasCompanyTags]="!!(sharedService.companyTagIds | async)?.size" [resetFilters]="reloadFilters" [apiLoading]="apiLoading" (actionRequested)="actionByTypeSplitter($event)"></app-clips-filters>
				}}
				@case ('SALES') { @if (showFilters) {
				<app-sales-filters [role]="'client'" [dataAdministrationType]="dataAdministrationType" [apiLoading]="apiLoading" [resetFilters]="filtersStore" (actionRequested)="actionByTypeSplitter($event)"></app-sales-filters>
				}}
				@case ('BANKRUPTCIES') { @if (showFilters) {
				<app-bankruptcies-filters [role]="'client'" [dataAdministrationType]="dataAdministrationType" [apiLoading]="apiLoading" [resetFilters]="filtersStore" (actionRequested)="actionByTypeSplitter($event)"></app-bankruptcies-filters>
				}}
				@case ('ANALYTICS') { @if (showFilters) {
				<app-analytics-filters [role]="'client'" [dataAdministrationType]="dataAdministrationType" [apiLoading]="apiLoading" [resetFilters]="filtersStore" (actionRequested)="actionByTypeSplitter($event)"></app-analytics-filters>
				}}
				@case ('TRANSCRIPTIONS') { @if (showFilters) {
				<app-transcriptions-filters [role]="'client'" [dataAdministrationType]="dataAdministrationType" [apiLoading]="apiLoading" [resetFilters]="filtersStore" [externalFilters]="externalFilters" (actionRequested)="actionByTypeSplitter($event)"></app-transcriptions-filters>
				}
				}
				@default { @if (showFilters) {
				<app-contract-notices-filters [role]="'client'" [apiLoading]="apiLoading" [dataAdministrationType]="dataAdministrationType" [resetFilters]="reloadFilters" [externalFilters]="externalFilters" [availableCountries]="availableCountries" (actionRequested)="actionByTypeSplitter($event)"></app-contract-notices-filters>
				}}
				}
			</div>
		</div>
	</aside>
	}
</div>
